import React from 'react';

import { TouchableOpacity, View } from 'react-native';

import { RoundedArrow } from 'assets/images';

import { COLOR } from 'utils/colors';

import { ArrowDirection } from 'screens/Epg/utils/epg-config';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    dateLabel: string;
    direction?: ArrowDirection;
    onPressMarker?: () => void;
};

const EpgJumpToDayMarker = ({
    dateLabel,
    direction = ArrowDirection.LEFT,
    onPressMarker,
}: Props) => {
    return (
        <TouchableOpacity
            style={[
                styles.container,
                direction === ArrowDirection.RIGHT && styles.rightContainer,
            ]}
            onPress={onPressMarker}
            testID={`EPG_JUMP_TO_${dateLabel}_ID`}
        >
            <View
                style={[
                    {
                        transform: [
                            {
                                scaleX:
                                    direction === ArrowDirection.LEFT ? 1 : -1,
                            },
                            {
                                translateX: 1,
                            },
                        ],
                    },
                ]}
            >
                <RoundedArrow height={24} fill={COLOR.LIGHT_TEAL} />
            </View>
            <View
                style={[
                    styles.textContainer,
                    styles.background,
                    direction === ArrowDirection.LEFT
                        ? styles.rightTextContainer
                        : styles.leftTextContainer,
                ]}
            >
                <Text
                    category={ETextCategory.caption1}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                    bold
                    color={ETextColor.black}
                    style={
                        direction === ArrowDirection.RIGHT &&
                        styles.textAlignRight
                    }
                >
                    {dateLabel}
                </Text>
            </View>
        </TouchableOpacity>
    );
};

export default EpgJumpToDayMarker;
